import { AutocompleteInput, ReferenceInput } from "react-admin";

const SaleOrderSelect = (props) => {
  return (
    <ReferenceInput
      source="sale_order_id"
      reference="sale-orders"
      perPage={20}
      sort={{ field: "sale_orders.created_at", order: "ASC" }}
      filter={{ "inventory_pendings.status": 1 }}
      enableGetChoices={() => true}
    >
      <AutocompleteInput
        variant="outlined"
        fullWidth
        optionText="code"
        openOnFocus
        filterToQuery={(searchText) => ({
          all: searchText || "",
        })}
        {...props}
      />
    </ReferenceInput>
  );
};

export default SaleOrderSelect;
